import { SET_COUNT } from './constants';

type State = {};

type Action = {
    +type: string,
    +payload: Object
};

const initialState = {};

export default function(state: State = initialState, action: Action) {
    switch (action.type) {
        case SET_COUNT:
            return {
                ...state,
                [action.payload.namespace]: action.payload.count
            };
        default:
            return state;
    }
}
